<template lang="pug">
.m-card
  .m-card-header(:id="'heading-oe-' + id" :data-bs-target="'#collapse-oe-' + id" :aria-controls="'collapse-oe-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_OE", 1) }}
  .m-card-body.collapse.show(:id="'collapse-oe-' + id" :aria-labelledby="'heading-oe-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group            
            .row
              template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
                OddsItem.col(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2" homeAway="1" mode="oe")
              template(v-else)
                OddsDisabled.col
              template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
                OddsItem.col(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2" homeAway="2" mode="oe")
              template(v-else)
                OddsDisabled.col
        .odds-wrapper(v-if="$helpers.objSize(details['oeh']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T
          .odds-group
            .row
              template(v-if="details['oeh'] && details['oeh'][0] && details['oeh'][0][5] != 0 && details['oeh'][0][5] != ''")
                OddsItem.col(:odds="details['oeh'][0]" idx=5 :typ="oddsType" dataType="2" homeAway="1" mode="oeh")
              template(v-else)
                OddsDisabled.col
              template(v-if="details['oeh'] && details['oeh'][0] && details['oeh'][0][7] != 0 && details['oeh'][0][7] != ''")
                OddsItem.col(:odds="details['oeh'][0]" idx=7 :typ="oddsType" dataType="2" homeAway="2" mode="oeh")
              template(v-else)
                OddsDisabled.col
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-oe-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-oe-' + id"
//-     :aria-controls="'collapse-oe-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_OE", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-oe-' + id"
//-     :id="'collapse-oe-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Odd") }}
//-               template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
//-                 OddsItem(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Even") }}
//-               template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
//-                 OddsItem(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
//-         .normal(v-if="mode == 0 || mode == 2")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Odd") }}
//-               template(v-if="details['oeh'] && details['oeh'][0] && details['oeh'][0][5] != 0 && details['oeh'][0][5] != ''")
//-                 OddsItem(:odds="details['oeh'][0]" idx=5 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Even") }}
//-               template(v-if="details['oeh'] && details['oeh'][0] && details['oeh'][0][7] != 0 && details['oeh'][0][7] != ''")
//-                 OddsItem(:odds="details['oeh'][0]" idx=7 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled

</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>
